import React from 'react';
import {Accordion, AccordionDetails, AccordionSummary, Box} from '@mui/material';
import clsx from 'clsx';
import {planFormClasses, PlanFormClassKey} from './planFormClasses';

interface PlanAccordionShellProps {
  expanded: boolean;
  disabled?: boolean;
  isSelected: boolean;
  validationLevel: PlanFormClassKey | null;
  greyed?: boolean;
  sameReview?: boolean;
  flat?: boolean;
  compact?: boolean;
  isSoleParent: boolean;
  summaryChildren: React.ReactNode;
  summaryTrailing?: React.ReactNode;
  detailsClassName?: string;
  children?: React.ReactNode;
}

export const PlanAccordionShell: React.FC<PlanAccordionShellProps> = ({
  expanded,
  disabled = false,
  isSelected,
  validationLevel,
  greyed = false,
  sameReview,
  compact,
  flat = false,
  isSoleParent,
  summaryChildren,
  summaryTrailing,
  detailsClassName,
  children,
}) => {
  const getValidationBG = (lvl: PlanFormClassKey) => {
    try {
      return planFormClasses[lvl];
    } catch {
      return {};
    }
  };

  return (
    <Accordion
      className={clsx(
        validationLevel,
        'plan-wrapper',
        sameReview ? 'same-review' : '',
        isSelected ? 'selected' : 'not-selected'
      )}
      sx={(theme) => ({
        borderRadius: 0,
        boxShadow: flat ? 'none' : theme.shadows[2],
        background: flat ? 'transparent' : undefined,
      })}
      data-type="InfoCapture"
      disabled={disabled}
      expanded={expanded}
      TransitionProps={{timeout: 0}}
    >
      <AccordionSummary
        expandIcon={null}
        style={{cursor: 'default', userSelect: 'text'}}
        sx={{
          ...getValidationBG(validationLevel as PlanFormClassKey),
          ...(greyed ? planFormClasses.na : {}),
          ...(!expanded ? {borderBottomLeftRadius: 4, borderBottomRightRadius: 4} : {}),
          ...{
            '& .MuiAccordionSummary-content': {margin: 0},
            '& .MuiAccordionSummary-content.Mui-expanded': {marginY: 1.5},
          },
          ...(isSoleParent
            ? {'&.MuiAccordionSummary-root': {minHeight: 60}}
            : {'&.MuiAccordionSummary-root': {minHeight: 0}}),
          borderTopLeftRadius: 4,
          borderTopRightRadius: 4,
          cursor: 'default',
          userSelect: 'text',
        }}
      >
        <Box
          display="flex"
          flexDirection="row"
          alignContent="center"
          alignItems="center"
          justifyContent="flex-start"
          ml={1}
          sx={{flex: 1}}
        >
          {summaryChildren}
        </Box>
        {summaryTrailing}
      </AccordionSummary>

      {expanded && children && (
        <AccordionDetails
          sx={{display: 'flex', flexDirection: 'column', gap: 1}}
          className={detailsClassName ?? 'plan-details'}
        >
          {children}
        </AccordionDetails>
      )}
    </Accordion>
  );
};
